import SearchPart from './SearchPart';
import TablePart from './TablePart';
import DetailPart from './DetailPart';
import EditPart from './EditPart';
import TitlePart from './TitlePart';
import MixPart from './MixPart';


export {
  SearchPart,
  TablePart,
  DetailPart,
  EditPart,
  TitlePart,
  MixPart
};



// WEBPACK FOOTER //
// ./src/Parts/index.js